import { createFileRoute } from "@tanstack/react-router"
import { UsersList } from "@/features/user-management/components"
import { usersListQuery } from "@/features/user-management/core/hooks/useUsersList"
import { usersListSearchSchema } from "@/features/user-management/core/types/filters"

export const Route = createFileRoute("/(authenticated)/settings/users/")({
  validateSearch: usersListSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => {
    void context.queryClient.ensureQueryData(usersListQuery(deps))
  },
  component: UsersList,
})
